import script from "./ViewRestroomRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewRestroomRecord.vue?vue&type=script&setup=true&lang=js"

import "./ViewRestroomRecord.vue?vue&type=style&index=0&id=720dde28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720dde28"]])

export default __exports__